import React, { FC } from "react";
import cls from "./customHeader.module.scss";
import {ArrowRoundedDown9x6Svg} from "../../../../svg";
import Link from "next/link";
import { IMenu } from "../../../../types/productPageTypes";
import {domainUrl} from "../../../../helper";

interface IProps {
    items: Array<IMenu>;
    openMenus: number[];
    toggleSub: (id: number) => void;
    dbName: string;
    domain: string;
}

const CustomItemList: FC<IProps> = ({ items, toggleSub, openMenus, dbName, domain }) => {
    return (
        <ul className={`${cls.menu__submenu}`}>
            {items.map((eachMenu, index) => {
                const { name = "", id, children = [], url_key = "", target, image } = eachMenu;
                const existThisMenuId = openMenus.some(subId => subId === id)
                let arrow = null;
                let submenu = null;
                if (children.length) {
                    arrow = <div className={`${cls.wrapper__bttn} ${existThisMenuId && cls.closed}`}>
                        <ArrowRoundedDown9x6Svg className={cls.menu__arrow}/>
                    </div>
                    submenu = <div className={`${cls.deep__submenu} ${existThisMenuId && cls.opened__drop}`}>
                        <CustomItemList items={children} toggleSub={toggleSub} openMenus={openMenus} dbName={dbName} domain={domain}/>
                    </div>
                }

                return (
                    <li className={cls.menu__li} key={index}>
                        <div className={cls.menu_item__container} onClick={e => {
                            toggleSub(id as number);
                            e.stopPropagation()
                        }}>
                            <button className={`${cls.link__button} ${!!children.length && cls.only__link}`} >
                                <Link href={url_key} prefetch={true}>
                                    <a
                                        className={cls.menu__li__a}
                                        {...target}
                                    >
                                        <div className={cls["name-icon__container"]}>
                                            {image ? <div className={cls.icon_wrapper}>
                                                <img
                                                    width={25}
                                                    height={25}
                                                    alt="menu icon"
                                                    src={domainUrl(`${dbName}/storage/${domain}/${image}`)}
                                                    loading="lazy"
                                                />
                                            </div> : null}
                                            {name}
                                        </div>
                                    </a>
                                </Link>
                            </button>
                            {arrow}
                        </div>
                        {submenu}
                    </li>
                );
            })}
        </ul>
    );
};

export default CustomItemList;
